<template>
    <div class="chart-progress" v-bind:class="classes">
        <div class="title" v-html="title"></div>
        <div class="flex-center">
            <div class="bar">
                <div class="progress " v-bind:style="{ width : calculated + '%' }" v-html="calculated.toFixed(0) + '%'"></div>
            </div>
            <div class="legend" v-html="legend"></div>
        </div>
    </div>
</template>

<script>
    module.exports = {

        created: function () {

        },
        data:function() {
            return {
                calculatedNumber:0,
                calculated:0,
                animationInterval:false
            }
        },
        watch: {
            progress:function(newValue) {
                this.setProgress()
            }
        },
        props:{
            title:{type:String,default:""},
            classes:{type:String},
            progress:{type:Number,default:0},
            legend:{type:String,default:""},
            range:{type:Number,default:100},
            animate:{type:Boolean,default:true},
            animationSpeed:{type:Number,default:1000}
        },
        methods: {
            setProgress() {
                var calculated = Math.round(((this.progress / this.range) * 100));
                var distance = parseFloat($(this.$el).css('width')) * (calculated / 100);
                if(this.animate) {
                    this.animationInterval = setInterval(function() {
                        if(this.calculated >= calculated) {
                            this.calculated = calculated;
                            clearInterval(this.animationInterval);
                        } else {
                            this.calculated += (distance / this.animationSpeed);
                        }
                    }.bind(this,distance),1);
                } else {
                    this.calculated = calculated;
                }
            }
        },
        mounted:function() {
            this.setProgress()
        }
    }
</script>
